// extracted by mini-css-extract-plugin
export default {"button":"SingleChoiceSelectionButtonNotification_button__ok0Gl","buttonSelected":"SingleChoiceSelectionButtonNotification_buttonSelected__4B91C"};